module.exports = (fox) => {
  if (console.warn) {
    console.warn(
      "[html5player package]: html5player folder is no longer maintainable and will be removed in next minor version."
    );
    console.warn(
      "[html5player package]: all widgets and other content moved to common-componnets/htmlplayer folder."
    );
  }

  const $ = fox.jQuery;

  require("script!html5player");

  require("./startBanner")(fox);
  require("./stopBanner")(fox);
  require("./endBanner")(fox);

  require("fox-dynamic-injection!fox-template-loader!../templates/html5player.tpl")(
    fox
  );

  require("../css/acplayer-icons.css");
  require("../css/acplayer.css");

  const url = require("../images/acplayer-robot-title.png");

  fox.registerWidget(
    "Html5Player",
    {
      configure: function (options) {
        this.registerOptions("", {
          container: "#player",
          renderPlayer: true,
          videoUrl: false,
          dontReuseSn: true,
          widgets: {
            controls: {
              widget: "Widget",
              template: "Html5Player_Controls",
              autoRender: true,
              widgets: {
                play: {
                  widget: "Widget",
                  template: "Html5Player_Play",
                  container: "#ac-p-play",
                  autoRender: true,
                },
                error: {
                  widget: "Widget",
                  template: "Html5Player_Error",
                  container: "#ac-p-error",
                  autoRender: true,
                  templateOptions: { url },
                },
                spinner: {
                  widget: "Widget",
                  template: "Html5Player_Spinner",
                  container: "#ac-p-spinner",
                  autoRender: true,
                },
                startBanner: {
                  widget: "Html5Player_StartBanner",
                  template: "Html5Player_StartBanner",
                  container: "#ac-p-start-banner",
                },
                stopBanner: {
                  widget: "Html5Player_StopBanner",
                  template: "Html5Player_StopBanner",
                  container: "#ac-p-stop-banner",
                },
                endBanner: {
                  widget: "Html5Player_EndBanner",
                  template: "Html5Player_EndBanner",
                  container: "#ac-p-end-banner",
                },
              },
            },
          },
          html5PlayerConfig: {
            originalSize: {
              min: 30,
              max: "auto",
            },
            movie: {
              container: ".ac-p-video-container",
              autoplay: false,
            },
            plugins: {
              spinner: true,
              startbanner: true,
              stopbanner: true,
              endbanner: true,
              timeline: true,
              error: {
                timer: 10,
              },
            },
            media: [500, 400],
          },
          handleWom: {
            runPlayer: {
              widget: "@this",
              event: "_changeFormat",
              callback: function () {
                if (!!this._player) {
                  this.resetPlayer();
                  this.runPlayer(null, this.rwom1("#controls"));
                }
              },
            },
          },
        });

        this.registerOptions(".Widget", {
          dontReuseSn: true,
        });

        this.callParent("configure", arguments);
      },

      init: function () {
        this._contentId = null;
        this._formatMap = {};
        this._videoFormat = null;
        this._bitrates = [];
        this._poster = null;
        this._endBanner = null;

        this.registerOptions("#controls", {
          container: this.getOption("renderTo") || this.getOption("container"),
        });

        this.callParent("init", arguments);
      },

      running: function () {
        this.runPlayer(null, this.rwom1("#controls"));

        this.callParent("running", arguments);
      },

      activate: function () {
        this.resetPlayer();

        this.runPlayer(null, this.rwom1("#controls"));

        this.callParent("activate", arguments);
      },

      deactivate: function () {
        this.resetPlayer();

        this.callParent("deactivate", arguments);
      },

      resetPlayer: function () {
        if (!!this._player) {
          this._player.destroy();
        }
        this._player = null;
      },

      playerCmd: function (cmd) {
        if (!this._player) {
          return false;
        }
        var params = Array.prototype.slice.call(arguments, 1);
        return this._player[cmd].apply(this._player, params);
      },

      getPlayerContainer: function () {
        if (this.visual) {
          this.playerContainer = this.rdom1(this.requireOption("renderTo"));
        } else {
          this.playerContainer = fox.dom.selectFirst(
            this.requireOption("container")
          );
        }

        if (!this.playerContainer) {
          return false;
        }

        if (!this.playerContainer.getAttribute("id")) {
          this.playerContainer.setAttribute("id", fox.uniqid("Html5Player"));
        }
        return this.playerContainer;
      },

      preparePlayerConfig: function () {
        this.getFormatMap();

        // if (fox.site.member && !this.getOption('disableTimeline') && typeof this.getOption('html5PlayerConfig.plugins.timeline')) {
        // 	this.setOption('html5PlayerConfig.plugins.timeline', {
        // 		theme: 'thumbs',
        // 		sprite:  (fox.getEnv('smallUrl') || 'https://ec-small.centrofiles.com/') + this.getContentId() + '/thumb/timeline/sprite/w135i',
        // 		thumbWidth: 135
        // 	});
        // }

        var conf = this.getOption("html5PlayerConfig"),
          src = this.getOption("videoUrl");

        if (src) {
          conf.movie.sources = [
            {
              type: "video/mp4",
              src: src,
            },
          ];
        } else {
          conf.plugins.formats = this.getBitrates() || false;
        }

        conf.plugins.poster = this.getPoster() || false;

        this.setOption("html5PlayerConfig", conf);

        return this;
      },

      embedPlayer: function () {
        this.preparePlayerConfig();

        var $container = $(this.getPlayerContainer());
        if (!$container.length) {
          return;
        }

        if (!this._player) {
          this.createHtml5Player();
        } else {
          this._player.update("poster", this.getPoster());
          this._player.update("formats", this.getBitrates());
        }
      },

      createHtml5Player: function () {
        var id =
          "#" +
          (this.getOption("domNodeContainerLink") === true
            ? this.getPlayerContainer()
            : this.getPlayerContainer().getAttribute("id"));
        var conf = this.getOption("html5PlayerConfig");

        var $el = this.rdom1(id);

        this._player = acplayer.create($el, conf);

        this.dispatchEvent("playerRunning");
      },

      runPlayer: function (params, controls) {
        var aliases = ["play", "error", "spinner"];
        var isEmbedded = aliases.every(function (alias) {
          return controls.rwom1("#" + alias).isEmbedded();
        });

        if (this.getOption("renderPlayer")) {
          if (isEmbedded) return this.embedPlayer();

          return fox.Promise.all(
            ["play", "error", "spinner"].map(function (alias) {
              return controls.rwom1("#" + alias).wait("addedToDom");
            })
          ).then(
            function () {
              this.embedPlayer();
            }.bind(this)
          );
        }
      },

      changeFormat: function (format) {
        this.setVideoFormat(format);
        this.buildBitrates().dispatchEvent("_changeFormat");
        return this;
      },

      setVideoFormat: function (value) {
        this._videoInfo = value;
        return value;
      },

      getVideoFormat: function () {
        return this._videoInfo;
      },

      setFormatMap: function (value) {
        this._formatMap = value;
        return this;
      },

      getFormatMap: function () {
        return this._formatMap;
      },

      setBitrates: function (value) {
        this._bitrates = value;
      },

      getBitrates: function () {
        return this._bitrates;
      },

      setPoster: function (value) {
        this._poster = value;
      },

      getPoster: function () {
        return this._poster;
      },

      setEndBanner: function (value) {
        this._endBanner = value;
      },

      getEndBanner: function () {
        return this._endBanner;
      },

      setContentId: function (value) {
        this._contentId = value;
      },

      getContentId: function () {
        return this._contentId;
      },
    },
    "Widget"
  );
};



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/htmlplayer/widget/html5player.es.js